import page from '../../../page.js';
import index from './index';
import router from './router';

page({
  vuePage:index,
  router:router,
  theme:{
    primary: {
      base: '#005276',
      lighten1: '#78C7C9',
      lighten2: '#BFE0E2',
      lighten3: '#BFE0E2',
      lighten4: '#EAF5F6',
      lighten5: '#EAF5F6',
    },
    secondary: '#00838D',
    accent: '#F39200',
    error: '#B30E0A'
  },
});


// WEBPACK FOOTER //
// ./src/pages/index/signup/app.js